import { SortOptionEnum, SortOption } from '../components/sort-options/types';
import {
  PRICE_SHIPPING_SORT,
  PRODUCT_VARIANT_SELECTED,
} from '../actions/product';
import { Variant } from '../../../types';

type State =
  | {
      campaigns: any[] | null;
      sort: SortOption;
      variant: Variant;
    }
  | undefined;

type Action =
  | {
      type: 'PRICE_SHIPPING_SORT';
      sort: SortOption;
    }
  | {
      type: 'PRODUCT_VARIANT_SELECTED';
      variant: Variant;
    }
  | {
      type: 'CAMPAIGNS_RECEIVE';
      campaigns: any[] | null;
    };

export default (state: State, action: Action) => {
  if (!state) {
    // variant.id === 0 corresponds to "all", which is set to default selected value here
    return { campaigns: null, variant: { id: 0 }, sort: SortOptionEnum.PRICE };
  }

  switch (action.type) {
    case 'CAMPAIGNS_RECEIVE': {
      return {
        ...state,
        campaigns:
          action.campaigns &&
          action.campaigns.filter(campaign => campaign.state === 'ACTIVE'),
      };
    }

    case PRICE_SHIPPING_SORT: {
      return {
        ...state,
        sort: action.sort,
      };
    }

    case PRODUCT_VARIANT_SELECTED: {
      return {
        ...state,
        variant: action.variant,
      };
    }

    default:
      return state;
  }
};
